import CryptoJS from 'crypto-js';

export const hashString = (input: string): string => {
    // Create a SHA-256 hash
    const hash = CryptoJS.SHA256(input);
    // Convert the hash to a hexadecimal string
    return hash.toString(CryptoJS.enc.Hex);
};

/** Stringify object and generate MD5 hash. */
export const genObjectId = (obj: object): string => {
    return CryptoJS.MD5(JSON.stringify(obj));
};
